import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Product } from '@/core/global-data/products.data';

interface Props {
    advantages: Product['advantages'];
}

const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.6 },
};

export default function ProductAdvantages({ advantages }: Props) {
    const { t } = useTranslation();

    return (
        <div className="md:mt-[70px] mt-[50px]">
            <motion.div {...fadeInUp}>
                <h3 className="text-[#145DA0] dark:text-[#86A4C0] font-cairo text-xl lg:text-[24px] leading-[100%] lg:leading-[28px] font-semibold text-start">
                    {t('products.advantagesLabel')}
                </h3>
                <div className="mt-4 border-b border-[#D1E1F5]" />

                <div className="mt-8 grid grid-cols-1 gap-y-5 sm:grid-cols-2 sm:gap-x-10 lg:gap-x-16">
                    {advantages?.map((advantage, index) => (
                        <motion.div
                            key={advantage.textKey}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.08, duration: 0.45 }}
                            viewport={{ once: true }}
                            className="flex items-start gap-3 text-start"
                        >
                            <span className="mt-0.5 dark:[&_svg]:brightness-0 dark:[&_svg]:invert flex h-5 w-5 shrink-0 items-center justify-center rounded-[6px] bg-card-icon border border-[#125592]">
                                <Check className="h-3 w-3 text-[#125592] " strokeWidth={3} />
                            </span>
                            <p className="font-alex text-product-dec font-normal text-sm leading-[26px] lg:text-[16px] lg:leading-[32px]">
                                {t(advantage.textKey)}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </div>
    );
}
